export default __webpack_public_path__ + "b573087cd0c96d80bfa996abb9eddc9b.svg";